import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { UserStorageService } from 'src/app/services/user-storage-service/user-storage.service';

@Component({
  selector: 'app-tickets-tickets-breadcrumb-card',
  templateUrl: './tickets-tickets-breadcrumb-card.component.html',
  styleUrls: ['./tickets-tickets-breadcrumb-card.component.scss']
})
export class TicketsTicketsBreadcrumbCardComponent implements OnInit {

  @Input() tickets;
  filterOpened: boolean;
  viewDisposition;

  constructor(private router: Router,
              private userStorageService: UserStorageService,
              private activatedRoute: ActivatedRoute,
              private ticketsService: TicketsService) {
                this.viewDisposition = 'grid';
              }

  ngOnInit() {
    // if (this.userStorageService.getFilterTickets()) {
    //   this.toggleBreadcrumbFilter();
    // }
  }

  public toggleViewDisposition(viewDis) {
    this.viewDisposition = viewDis;
    this.ticketsService.toggleTicketsDisposition(viewDis);
  }

  public createTicket() {
    this.router.navigate(['../ticket'], { relativeTo: this.activatedRoute.parent });
  }

  // public toggleBreadcrumbFilter() {
  //   this.filterOpened = !this.filterOpened;
  // }

  public search(event) {
    this.ticketsService.searchTickets(event.target.value);
  }
}
